"use client";

import { useCallback, useState } from "react";
import { getUserFacingError } from "@/lib/api-errors";

type SubmitFn<T> = (data: T) => Promise<unknown>;

export function useFormSubmit<T>(submitFn: SubmitFn<T>) {
  const [status, setStatus] = useState<
    "idle" | "loading" | "success" | "error"
  >("idle");
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(
    async (data: T) => {
      setStatus("loading");
      setError(null);
      try {
        await submitFn(data);
        setStatus("success");
        return true;
      } catch (e) {
        setStatus("error");
        setError(getUserFacingError(e));
        return false;
      }
    },
    [submitFn]
  );

  const reset = useCallback(() => {
    setStatus("idle");
    setError(null);
  }, []);

  return { submit, status, error, reset, isLoading: status === "loading" };
}
